import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React from 'react';
import Tabs from '..';
import Tab from '../tab';
import Group from './group';
import { TabsThemeEx, TabThemeEx, TabTitle } from './styles';
/*::
import type { Node } from 'react';

type TabType = {|
  id: string,
  title: Node,
  icon: Node,
  active?: boolean,
|};
type GroupType = {|
  title: string,
  tabs: Array<TabType>,
|};

type TabsUstylePropsType = {|
  groups: Array<GroupType>,
  onChange?: (id: string) => void,
  children?: Node,
  rest?: any,
|};
*/

var TabsUstyle = function TabsUstyle(_ref
/*: TabsUstylePropsType */
) {
  var groups = _ref.groups,
      _ref$onChange = _ref.onChange,
      _onChange = _ref$onChange === void 0 ? function () {
    return undefined;
  } : _ref$onChange,
      children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, ["groups", "onChange", "children"]);

  var initialTabId = groups && groups[0] && groups[0].tabs && groups[0].tabs[0] && groups[0].tabs[0].id;

  if (!initialTabId) {
    throw new Error('heroMenuItems must be present in the first group.');
  }

  return /*#__PURE__*/React.createElement(Tabs, {
    value: initialTabId,
    panels: children,
    onChange: function onChange(id) {
      return _onChange(id);
    },
    theme: TabsThemeEx
  }, groups.map(function (group
  /*: GroupType */
  ) {
    return /*#__PURE__*/React.createElement(Group, {
      title: group.title,
      key: group.title
    }, group.tabs.map(function (tab
    /*: TabType */
    ) {
      return /*#__PURE__*/React.createElement(Tab, Object.assign({
        id: tab.id,
        active: tab.active,
        key: tab.id,
        theme: TabThemeEx
      }, rest), tab.icon, /*#__PURE__*/React.createElement(TabTitle, null, tab.title));
    }));
  }));
};

export default TabsUstyle;